import styled from 'styled-components'
// import styled, { createGlobalStyle } from 'styled-components'

// // === Estilo Global para Reset Básico ===
// const GlobalStyle = createGlobalStyle`
//   * {
//     margin: 0;
//     padding: 0;
//     box-sizing: border-box;
//   }

//   body {
//     font-family: 'Segoe UI', sans-serif;
//     background-color: #f3f4f6; /* gray-100 */
//   }

//   button {
//     cursor: pointer;
//     outline: none;
//     border: none;
//   }
// `

// === Container Principal do Webphone ===
export const WebPhoneContainer = styled.div`
  position: ${(props) => (props.minimized ? 'fixed' : 'fixed')};
  left: ${(props) => (props.minimized ? 'auto' : props.left)}px;
  top: ${(props) => (props.minimized ? 'auto' : props.top)}px;
  right: ${(props) => (props.minimized ? '20px' : 'auto')};
  bottom: ${(props) => (props.minimized ? '20px' : 'auto')};
  z-index: 9999;
  width: ${(props) => (props.minimized ? '50px' : '280px')};
  height: ${(props) => (props.minimized ? '50px' : '620px')};
  transition: ${(props) => (props.isDragging ? 'none' : 'all 0.3s ease')};
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: ${(props) => (props.minimized ? '50%' : '8px')};
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  /* overflow: ${(props) => (props.minimized ? 'hidden' : 'visible')}; */
  overflow: 'hidden';
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  /* position: fixed;
  left: ${(props) => props.left}px;
  top: ${(props) => props.top}px;
  z-index: 9999;
  width: 360px;
  height: ${(props) => (props.minimized ? '40px' : '800px')};
  transition: height 0.3s ease;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: ${(props) => (props.minimized ? 'hidden' : 'visible')}; */
`

// === Header do Webphone ===
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #4f46e5; /* indigo-600 */
  color: white;
  padding: 8px 12px;
  cursor: move;
  width: 100%;
`

// === Botão no Header ===
export const ToggleButton = styled.button`
  background-color: #6366f1; /* indigo-500 */
  color: white;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.8rem;

  &:hover {
    background-color: #4f46e5;
  }
`

// === Iframe Wrapper ===
export const IframeWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`

// === Iframe ===
export const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`

// === Rodapé com botões ===
export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px;
`

// === Botão de Fechar ===
export const CloseButton = styled.button`
  font-size: 0.75rem;
  color: #ef4444; /* red-500 */

  &:hover {
    color: #dc2626; /* red-600 */
  }
`
